import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CrmPipeline from './CrmPipeline';
import '../components/erp/Erp.css';

export function CrmPipelineRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('tab', 'pipeline');
  return <Navigate to={`/crm?${params.toString()}`} replace />;
}

export default function CrmWorkspace() {
  return <CrmPipeline />;
}
